import React, {useEffect, useState} from "react";
import HelperService from "../../services/helper-service";
import helperService from "../../services/helper-service";
import {AttachmentTypes} from "../../utils/constants";
import Section from "../section";
import Attachments from "../attachments/attachments";

export default function ArticleDetailContent({ article, ...props}) {
  const [cover, setCover] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(()=>{
    if (article){
      let ci = HelperService.getObjByKey(article.attachments, 'attachment_type_id', AttachmentTypes.cover.val);
      setCover(ci ? ci : null);
      setDetail(article);
    } else {
      setCover(null);
      setDetail(null);
    }
  }, [article]);

  return (
    <>
      {detail && <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">
          <div className="row">

              <Section animation={HelperService.getRandomAnimation()}>
                <div className="col-12 mb-4">
                  <div className="card h-100 p-relative mb-0">
                    <div className='row'>
                      <div className='col-sm-12'>
                        {cover && <img src={cover?.url} className="w-100 rounded-top" alt="" />}
                      </div>
                      <div className='col-sm-12'>
                        <div className="card-body">
                          <h1 className={`mb-0`}>{detail.title}</h1>
                          <span className={`badge bg-indigo`}>{helperService.formatDateTime(detail.created_at)}</span>
                          <div className="card-text mt-3" dangerouslySetInnerHTML={{__html: detail.article}}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Section>

              <Section animation={HelperService.getRandomAnimation()}>
                <h2>Dokumenty</h2>
                <div className="col-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      {!detail?.attachments?.length>0 &&
                          <div className="card-body text-center">
                            <p className="text-muted">Zatiaľ prázdne :)</p>
                          </div>}
                      {detail?.attachments?.length>0 && <Attachments attachments={detail.attachments} />}
                    </div>
                  </div>
                </div>
              </Section>

          </div>
        </div>
      </Section>}
    </>
  );
}
